import { GivelifyLabel, GivelifyTextField } from '@givelify/givelify-ui';
import { GivelifyNotification } from '@givelify/ui';
import { styled } from '@mui/material';

export const SettingContent = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export const SettingDesc = styled(GivelifyLabel)(() => ({
    whiteSpace: 'normal',
}));

export const TurnSetting = styled('div')(({ theme }) => ({
    marginBottom: theme.spacing(6),
}));

export const CredentialContent = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(6),
}));

export const FormControl2 = styled(GivelifyTextField)(() => ({
    border: 'none',
    boxShadow: 'none',
    '& > label': {
        background: '#fff',
        padding: '0 5px',
    },
    '&:focus': {
        outline: 'none',
    },
}));
export const ErrorNotification = styled(GivelifyNotification)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

export const BetaSignUpField = styled('div')(() => ({
    textAlign: 'right',
}));
